module.exports = __webpack_public_path__ + "static/media/addPhoto2.27c6f4fd.png";